import { useState } from 'react';

export default function usePagination(rows, resetKey = '', pageSize = 50) {
  const [state, setState] = useState({ key: resetKey, page: 1 });
  const pages = Math.max(1, Math.ceil(rows.length / pageSize));
  const page = state.key === resetKey ? Math.min(state.page, pages) : 1;
  const setPage = next => setState({ key: resetKey, page: Math.max(1, Math.min(next, pages)) });
  return { rows: rows.slice((page - 1) * pageSize, page * pageSize), page, pages, total: rows.length, setPage };
}
